import { render, staticRenderFns } from "./vpn.vue?vue&type=template&id=562d3a96&scoped=true"
import script from "./vpn.vue?vue&type=script&lang=js"
export * from "./vpn.vue?vue&type=script&lang=js"
import style0 from "./vpn.vue?vue&type=style&index=0&id=562d3a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562d3a96",
  null
  
)

export default component.exports